import { useLocation } from "react-router-dom";
import { pageItems } from '../data/data'


export const TitleBar = () => {
    const location = useLocation();
    const currentPage = pageItems.find((item) => item.link === location.pathname);

    return (
        <div className={"titlebar-"+currentPage.key}>
            <h3>
                {currentPage ? currentPage.name : '페이지를 찾을 수 없습니다'}
            </h3>
        </div>
    );

};